<template>
  <section>
    <!-- Video ********************************************************************-->
    <header>
      <!-- <button class='video-seguimiento' @click="openModal()">{{ $t('seguimiento.showVideo') }}</button> -->
      <a href="https://cancilleria.gob.bo/apostilla/tutoriales/" target="_blank">
        <button class='video-seguimiento'>{{ $t('seguimiento.showVideo') }}</button>
      </a>
    </header>
    <!-- Modal -->
    <article class="modal" ref="modal" @click="closeModal()">
      <div class="modal-content portada">
        <header><span class="close">&times;</span></header>
        <div class="modal-body">
          <h2 class="title">{{ $t('seguimiento.video') }}</h2>

          <iframe v-if="showModal" width="560" height="315" src="https://www.youtube.com/embed/oAknfvV_nEA?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          <p v-html="$t('inicio.modal.important')"></p>
        </div>
      </div>
    </article>
    <!-- End Video ********************************************************************-->

    <h3 class="title text-center" v-if="!tramite">{{ $t('seguimiento.title') }}</h3>
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="buscar" v-if="!tramite" class="grid-form">
          <div class="alert alert-info">
            <i class="icon-info"></i> {{ $t('fields.ingrese_codigo_seguimiento') }}
          </div>
          <div class="grid cols-2">
            <div class="grid cols-2">
              <div class="form-group required" :class="{ 'error-input': errors.has('codigo') }">
                <label for="codigo">{{ $t('fields.codigo') }}</label>
                <input
                  type="text"
                  v-model="codigo"
                  id="codigo"
                  name="codigo"
                  autofocus
                  maxlength="8"
                  v-validate="'required'"
                  autocomplete="off"
                  class="form-control">
                <span v-show="errors.has('codigo')" class="error-help">{{ errors.first('codigo') }}</span>
              </div>
              <div class="form-group">
                <label for="">&nbsp;</label>
                <button class="btn btn-primary" type="submit">{{ $t('btn.search') }} <i class="icon-checkmark"></i></button>
              </div>
            </div>
          </div>
        </form>
        <div v-if="tramite" class="tramite-detalle grid-form">
          <div class="grid detalle">
            <h3 class="title">{{ $t('fields.det_tramite') }}</h3>
            <div class="info">
              <div><strong>{{ $t('fields.fecha_solicitud') }}: </strong>{{ $util.formatDate(tramite.fecha_inicio) }}</div>
              <div><strong>{{ $t('fields.estado') }}:</strong> {{ tramite.estado }}</div>
            </div>
          </div>
          <h4 class="title">{{ $t('fields.datos_del_solicitante')}}</h4>
          <div class="grid cols-3">
          <div class="form-group">
            <label for="">{{ $t('fields.nombre_solicitante') }}</label>
            <p class="form-control">{{ tramite['solicitante.nombres'] }} {{ tramite['solicitante.primer_apellido'] }} {{ tramite['solicitante.segundo_apellido'] }}</p>
          </div>
            <div class="form-group">
              <label for="">{{ $t('fields.email') }}</label>
              <p class="form-control">{{ tramite['solicitante.email'] }} </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t('fields.telefono') }}</label>
              <p class="form-control">{{ tramite['solicitante.telefono'] }} </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t('fields.tipoDoc') }}</label>
              <p class="form-control">{{ tipoDocs[tramite['solicitante.tipo_documento']] }} </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t('fields.nroDoc') }}</label>
              <p class="form-control">{{ tramite['solicitante.nro_documento'] }} </p>
            </div>
            <div class="form-group">
              <label for="">{{ $t('fields.fecha_nacimiento') }}</label>
              <p class="form-control">{{ $util.formatDate(tramite['solicitante.fecha_nacimiento']) }} </p>
            </div>
          </div>
          <h4 class="title">{{ $t('fields.docs')}}</h4>
          <div class="documentos grid cols-2">
            <div class="documento card" v-for="(item, index) in tramite.documentos">
              <div class="grid estado">
                <div>
                  <h5 class="title">{{ index + 1 }}. {{ item['documento.nombre'] }}</h5>
                  <p>{{ item['documento.descripcion'] }}</p>
                  <p class="entidad"><small>{{ item['documento.entidad.nombre'] }}</small></p>
                </div>
                <div class="text-right">
                  <div class="precio">{{ $t('fields.estado') }}:
                    <strong v-if="item.estado === 'FIRMADO_ENTIDAD' && item['documento.derivar'] === 'CANCILLERIA' ">
                      CREADO
                    </strong>
                    <strong v-else>
                      {{item.estado.replace('_', ' ')}}
                    </strong>
                  </div>
                  <div class="precio" v-if="item.estado==='REVISADO_CANCILLERIA'" >{{ $t('fields.precio') }}: <strong>{{ item['documento.monto'][0].monto || 0 }}</strong> Bs.</div>
                </div>
              </div>
              <div class="form-group alert alert-warning" v-if="item.observacion">
                <label for="">Observación</label>
                <p>{{ item.observacion }}</p>
              </div>
              <div class="grid cols-2">

                <!--<div class="form-group" v-if="item['documento.derivar'] == 'ENTIDAD'">
                  <label>
                    <span class="mr-10">{{ $t('fields.pago_entidad') }}:</span> <i :class="{ 'icon-checkmark': item.pago_entidad, 'icon-cross': !item.pago_entidad }"></i>
                    <strong>{{ item.pago_entidad ? 'SI' : 'NO' }}</strong></label>
                </div>-->

                <div class="form-group">
                  <label>
                    <span class="mr-10">
                      {{ $t('fields.pago_cancilleria') }}:
                    </span>
                    <i :class="{ 'icon-checkmark': item.pago_cancilleria, 'icon-cross': !item.pago_cancilleria }"></i>
                    <strong>{{ item.pago_cancilleria ? 'SI' : 'NO' }}</strong>
                  </label>
                  <label>
                    <span class="mr-10">
                      Tipo de apostilla:
                    </span>
                    <strong>{{ item.digital ? 'Digital' : 'Impresa' }}</strong>
                  </label>
                  <label>
                    <span class="mr-10">
                      Departamento:
                    </span>
                    <strong>{{ item.departamento }}</strong>
                  </label>
                </div>
                <div class="form-group">
                  <h5 class="title" v-if="item.estado === 'CREADO'">
                    Diríjase con sus documentos a: <strong>{{ item['documento.entidad.nombre'] }}</strong>
                  </h5>
                  <h5 class="title" v-if="item.estado === 'FIRMADO_ENTIDAD' || item.estado === 'REVISADO_CANCILLERIA'">
                    Su trámite se encuentra en: <strong>CANCILLERIA</strong>
                  </h5>
                  <h5 class="title" v-if="item.estado !== 'CREADO' && item.estado !== 'FIRMADO_ENTIDAD' && item.estado !== 'REVISADO_CANCILLERIA' && item.estado !== 'APOSTILLADO' && item.estado !== 'ANULADO'">
                    Su trámite se encuentra en: <strong>{{ item['documento.entidad.nombre'] }}</strong>
                  </h5>
                </div>
              </div>
              <div class="grid cols-3">
                <div class="form-group" v-if="item.cod_seguridad">
                  <label for="">{{ $t('fields.cod_seguridad') }}</label>
                  <p class="form-control datos-verificacion">{{ item.cod_seguridad }}</p>
                </div>
                <div class="form-group" v-if="item.nro_apostilla">
                  <label for="">{{ $t('fields.nro_apostilla') }}</label>
                  <p class="form-control datos-verificacion">{{ item.nro_apostilla }}</p>
                </div>
                <div class="form-group" v-if="item.fecha_expedicion">
                  <label for="">{{ $t('fields.fecha_expedicion') }}</label>
                  <p class="form-control datos-verificacion">{{ item.fecha_expedicion | fecha }}</p>
                </div>
              </div>
            </div>
            <!-- <div class="total">
              Total a pagar: {{ total() }} Bs.
            </div> -->
          </div>
          <div class="btn-container">
            <button class="btn" @click="back">{{ $t('btn.back') }} <i class="icon-arrow-left2"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

const tipoDocs = {
  CI: 'CÉDULA DE IDENTIDAD',
  PASAPORTE: 'PASAPORTE',
  EXTRANJERO: 'DOCUMENTO DE IDENTIFICACIÓN EXTRANJERO'
};

export default {
  data () {
    return {
      showModal: false,
      codigo: '',
      tramite: null,
      tipoDocs
    };
  },
  methods: {
    async buscar () {
      if (await this.$validator.validateAll()) {
        this.$service.get(`tramite/${this.codigo}`)
        .then(response => {
          if (response) {
            this.tramite = response;
          }
        });
      }
    },
    back () {
      this.tramite = null;
      this.codigo = '';
    },
    // Modal ********************************************************************
    openModal () {
      this.showModal = true;
      this.$refs.modal.style.display = 'block';
    },
    closeModal () {
      this.showModal = false;
      this.$refs.modal.style.display = 'none';
    }
  },
  filters: {
    fecha: function (value) {
      if (!value) return '';
      return moment(String(value)).format('DD/MM/YYYY');
    }
  }
};
</script>

<style lang="scss">
@import 'pages.scss';
.tramite-detalle {
  .documentos {
    .card {
      padding: 20px;
    }
  }

  .alert {
    margin-top: 10px;
  }

  .documentos {
    .precio {
      margin-bottom: 5px;
      text-align: center;
      font-size: 0.8rem;

      &:first-child {
        background-color: $primary;
      }
    }
  }
}
.grid {
  &.detalle {
    grid-template-columns: 3fr 1fr;

    .info {
      margin-top: 10px;
    }
  }
  &.estado {
    grid-template-columns: 4fr 2fr;
    margin-bottom: 15px;
  }
}
.datos-verificacion {
  font-family: monospace;
  font-size: 16px !important;
}

// Modal ---------------------------------
.video-seguimiento {
  padding: 5px 15px;
  background: #7dc200;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.video-seguimiento:hover {
  background: #95e407;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 30; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.modal-content header {
  padding: 0px 20px;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

/* The Close Button */
.close {
  color: #000;
  float: right;
  font-size: 36px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  text-decoration: none;
  cursor: pointer;
  color: #707070
}

.modal-body {padding: 20px; text-align: center;}

@media (max-width: 868px) {
  .modal-content {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Seguimiento.vue